import { useContext } from 'react';

import type { IContext } from './Context';
import Context from './Context';

export { default as Provider } from './Provider';
export type { User, UserManagerSettings } from './Auth';

export function useAuth(): IContext {
  return useContext(Context);
}
